import { render, staticRenderFns } from "./Authoring.vue?vue&type=template&id=b8098820"
import script from "./Authoring.vue?vue&type=script&lang=js"
export * from "./Authoring.vue?vue&type=script&lang=js"
import style0 from "./Authoring.vue?vue&type=style&index=0&id=b8098820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports